import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import { FC, ReactElement } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { Header } from '../Header'
import { Section1 } from '../Section-1'
import { Section2 } from '../Section-2'
import { Section3 } from '../Section-3'
import { Section4 } from '../Section-4'
import { Section5 } from '../Section-5'
import { Section6 } from '../Section-6'
import { Section7 } from '../Section-7'
import { Popular } from '../Popular'

const defaultProperties: { [key: string]: string } = {
  module: 'section1', // header / section1 / section2 / section3 / section4 / popular
}

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties = defaultProperties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const modules: { [key: string]: ReactElement } = {
    header: (
      <Header
        title={
          'Die beliebtesten Hunderassen der Schweiz und wo sie am häufigsten vorkommen'
        }
        titleMobile={
          'Die beliebtesten Hunderassen der Schweiz und wo sie am häufigsten vorkommen'
        }
        lead={
          'Seit der Corona-Pandemie gibt es deutlich mehr Hunde. Wir zeigen, in welchen Gemeinden besonders viele leben, wie alt sie werden und welche Namen beliebt sind.'
        }
        articleID='205586825473'
        tenant={tenant}
        colorMode={colorMode}
      />
    ),
    popular: <Popular tenant={tenant} colorMode={colorMode} />,
    section1: <Section1 colorMode={colorMode} />,
    section2: <Section2 colorMode={colorMode} />,
    section3: <Section3 colorMode={colorMode} />,
    section4: <Section4 colorMode={colorMode} />,
    section5: <Section5 colorMode={colorMode} />,
    section6: <Section6 colorMode={colorMode} />,
    section7: <Section7 colorMode={colorMode} />,
  }

  return (
    <AppContainer className={globalClasses.join(' ')}>
      {properties?.module && modules[properties.module]}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
